/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { PACKAGE_NAME } from '@jira/navigation-apps__atlassian-navigation-ui/src/constants.tsx';
import type { BadgeProps as BadgeType } from '@atlaskit/badge/types';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const Notifications = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-atlaskit-badge" */ '@atlaskit/badge'),
	{ ssr: false },
);

export const LazyNotifications = (props: BadgeType): React.JSX.Element => (
	<JSErrorBoundary id="help.atlaskit-badge" packageName={PACKAGE_NAME} teamName="navigation">
		<Placeholder name="lazy-notification-badge" fallback={null}>
			<Notifications {...props} />
		</Placeholder>
	</JSErrorBoundary>
);
